import request from '../../utils/request'
import store from '../../store/index'

// 获取日志列表
export const getLogList = (info) => {
  return request({
    url: '/admin-getEventMessages',
    method: 'get',
    params: {
      page: store.getters.currentPage,
      page_size: store.getters.pageSize,
      ...info
    }
  })
}
// 获取事件消息详情
export const getEventMessageDetail = (event_message_id) => {
  return request({
    url: '/admin-getEventMessageDetail',
    method: 'GET',
    params: {
      event_message_id
    }
  })
}